import type { DateFormatPreference, MeasurementSystem, SupportedLanguage, UserPreferences } from "../types/domain";

export const APP_NAME = "Mundely";
export const RECOVERY_RETENTION_DAYS = 30;
export const SCHEMA_VERSION = 1;

export const SUPPORTED_LANGUAGES: Array<{ code: SupportedLanguage; label: string }> = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" }
];

export const DATE_FORMATS: DateFormatPreference[] = ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"];
export const MEASUREMENT_SYSTEMS: MeasurementSystem[] = ["metric", "imperial"];
const FALLBACK_CURRENCIES = [
  "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN",
  "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD",
  "CAD", "CDF", "CHF", "CLP", "CNY", "COP", "CRC", "CUP", "CVE", "CZK",
  "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR",
  "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD",
  "HKD", "HNL", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK",
  "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT",
  "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN",
  "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR",
  "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR",
  "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SOS", "SRD", "SSP", "STN", "SYP", "SZL",
  "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS",
  "UAH", "UGX", "USD", "UYU", "UZS", "VES", "VND", "VUV", "WST",
  "XAF", "XCD", "XOF", "XPF", "YER", "ZAR", "ZMW", "ZWL"
];

export const CURRENCIES: string[] = (() => {
  const intl = Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] };
  try {
    const values = intl.supportedValuesOf?.("currency");
    if (Array.isArray(values) && values.length > 0) return [...values].sort();
  } catch {
    // Older WebViews use the fallback list below.
  }
  return FALLBACK_CURRENCIES;
})();

export function defaultLanguageFromDevice(): SupportedLanguage {
  const code = (navigator.language || "en").slice(0, 2).toLowerCase();
  if (code === "it" || code === "es") return code;
  return "en";
}

export function defaultPreferences(language = defaultLanguageFromDevice()): UserPreferences {
  return {
    language,
    currency: language === "it" || language === "es" ? "EUR" : "USD",
    measurementSystem: "metric",
    dateFormat: language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY",
    theme: "default",
    usefulInfoLayout: "1",
    usefulInfoLayoutVersion: 2,
    itineraryLayout: "1",
    timelineLayout: "2",
    buttonColor: "#124848",
    buttonRadius: "12",
    widgetStyle: "default",
    bottomBarStyle: "default",
    notifications: {
      operational: true,
      reminders: true,
      ai: true,
      collaboration: true,
      marketing: false
    }
  };
}
